
import './FormFilterWrapper.scss';

const FormFilterWrapper = ({children}) =>
{

    return (
        <div className='user-filter-div-outer'>
            {children.map((filter, index) =>
            {
                return (<div className='user-filter-div-inner' key={index}>
                    {filter}
                </div>)
            })}
        </div>
    )

}

export default FormFilterWrapper;
